import { createClient } from '@supabase/supabase-js'
import { isOnPremDeployment } from './deploymentConfig'

// Load and validate environment variables (only for cloud deployment)
const loadEnvironmentVariables = () => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

  // For on-prem deployment, Supabase credentials are not required
  if (isOnPremDeployment()) {
    // Return dummy values - they won't be used
    return { supabaseUrl: 'http://localhost', supabaseAnonKey: 'dummy' }
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY environment variables are required for cloud deployment')
  }

  return { supabaseUrl, supabaseAnonKey }
}

// Load environment variables
const { supabaseUrl, supabaseAnonKey } = loadEnvironmentVariables()

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    storageKey: 'membrowse-auth',
    flowType: 'pkce'
  }
}) 